import React from "react";

function ApplyCoupon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 9.84836L0 1.875C0 0.839453 0.839453 0 1.875 0L9.84836 0C10.3456 2.6003e-06 10.8225 0.197548 11.1742 0.54918L19.4508 8.82582C20.183 9.55805 20.183 10.7452 19.4508 11.4775L11.4775 19.4508C10.7452 20.183 9.55805 20.183 8.82582 19.4508L0.54918 11.1742C0.197548 10.8225 2.6003e-06 10.3456 0 9.84836H0ZM4.375 2.5C3.33945 2.5 2.5 3.33945 2.5 4.375C2.5 5.41055 3.33945 6.25 4.375 6.25C5.41055 6.25 6.25 5.41055 6.25 4.375C6.25 3.33945 5.41055 2.5 4.375 2.5Z"
        fill="#0066CC"
      />
    </svg>
  );
}

export default ApplyCoupon;
